import { executeTwoStepEventQuery } from './execute';
import fromUsersResult from '../converters/usersConverter';
import buildDashboardUsersQuery from '../converters/usersDashboadApiConverter';

const executeDashboardUsersQuery = (unit, executeId) => (dispatch, getState) => {
  const query = buildDashboardUsersQuery(getState(), unit);
  return executeTwoStepEventQuery(query, executeId, dispatch, getState).then((response) => ({
    events: fromUsersResult(response, query),
    unit,
  }));
};

export default executeDashboardUsersQuery;
